function booking() {
  return (
    <div>
      <h1>booking</h1>
      <p>loading</p>
    </div>
  );
}

export default booking;
